<template>
  <div class="card">
    <div class="card-header">
      <h4 class="mb-0">
        {{ $t('PQTOffersView.qiymtTklifiMqaissi') }}
      </h4>
    </div>
    <div class="row pl-5 align-end">
      <b-button
        class="col-4 mr-5 ml-4"
        @click="showOnlyPriceComparison = true"
      >
        {{ $t('newRFQRequest.yalnzQiymtMqayissi') }}
      </b-button>
      <b-button
        class="col-4 ml-5"
        @click="showDetailedView = true"
      >
        {{ $t('newRFQRequest.traflMqayis') }}
      </b-button>
    </div>
    <b-modal
      v-model="showDetailedView"
      size="xl"
    >
      <template #modal-title>
        {{ $t('traflMqayis') }}
      </template>
      <div class="modal-body">
        <div
          v-for="offer in offers"
          :key="offer.id"
          class="offer-container mb-6"
        >
          <b-row>
            <b-col
              md="12"
              class="mb-2"
            >
              {{ offer.requestUser.company.name }}
            </b-col>
          </b-row>
          <b-row
            v-for="(priceDetail, i) in getParsedPrices(offer)"
            :key="priceDetail.product"
            class="mb-5"
          >
            <b-col md="1">
              <strong>{{ getProduct(priceDetail.product).name }}</strong>
            </b-col>
            <b-col md="1">
              {{ $t('miqdar', {count: getProduct(priceDetail.product).count}) }}
            </b-col>
            <b-col md="1">
              {{ $t('qiymt', {price: priceDetail.price}) }}
            </b-col>
            <b-col md="6">
              <table class="table">
                <tbody>
                  <tr
                    v-for="requirement in getProduct(priceDetail.product).requirements"
                    :key="requirement.id"
                    class="align-top custom-row-height"
                  >
                    <td class="w-50">
                      {{ requirement.requirement }}
                    </td>
                    <td class="w-50">
                      {{ getRequirementReply(priceDetail, requirement.id) || '-' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col md="3">
              <b-button
                v-if="i === 0"
                class="mb-3"
                variant="primary"
                size="md"
                @click="startConversation(offer.requestUser.id)"
              >
                {{ $t('mzakirEt') }}
              </b-button>
              <b-row>
                <div
                  v-for="(f, ii) in priceDetail.techSpecsFiles"
                  :key="ii"
                >
                  <div
                    v-if="f && f !== '' && f !== 'undefined'"
                    class="position-relative file-style"
                  >
                    <a
                      v-if="isPhoto(f)"
                      target="_blank"
                      :href="getPhoto(f,'')"
                    >
                      <img
                        :src="getPhoto(f,'thumbnailCropped')"
                        class="img-thumbnail"
                        style="max-height: 60px;"
                        :alt="$t('newRequest.requestPhoto')"
                      >
                    </a>
                    <a
                      v-else
                      target="_blank"
                      :href="getPhoto(f,'')"
                      style="max-height: 60px; max-width: 60px;"
                      class="card border border-dark"
                    >
                      <div class="card-body d-flex text-dark justify-content-center align-items-center ">
                        *.{{ f.split('.').pop() }}
                      </div>
                    </a>
                  </div>
                </div>
              </b-row>
            </b-col>
            <b-col
              md="3"
              class="mt-3 mr-3"
            >
              <label>{{ $t('spesifikasiyaHaqqndaQeydlr') }}</label>
            </b-col>
            <b-col
              md="6"
              class="mt-3 w-50"
            >
              {{ getTechSpecification(offer, priceDetail.product).techSpecification }}
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <div class="font-weight-bold">
                {{ $t('mumiMbl', {totalPrice: offer.totalPrice}) }}
              </div>
              <div class="mt-1">
                {{ $t('tklifinEtibarllqMddti', {valid: getParsedPricesExtras(offer).valid}) }}
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="mt-1">
                {{ $t('mumiFayllar') }}
              </div>
              <div class="row">
                <div
                  v-for="(f,i) in getParsedPricesExtras(offer).files.split(',')"
                  :key="i"
                  class="col-2 mt-2"
                >
                  <div class="position-relative">
                    <a
                      v-if="isPhoto(f)"
                      target="_blank"
                      :href="getPhoto(f,'')"
                    >
                      <img
                        :src="getPhoto(f,'thumbnailCropped')"
                        class="img-thumbnail"
                        style="max-height: 100px;"
                        :alt="$t('newRequest.requestPhoto')"
                      >
                    </a>
                    <a
                      v-else
                      target="_blank"
                      :href="getPhoto(f,'')"
                      style="max-height: 6rem; max-width: 7rem;"
                      class="card border border-dark"
                    >
                      <div class="card-body d-flex text-dark justify-content-center align-items-center">
                        {{ $t('newAUCRequest.lavFayl') }} <br>*.{{ f.split('.').pop() }}
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="row pl-5 align-end p-10">
          <b-button
            class="col-4 mr-5"
            @click="exportResultsDetailedPrice('xlsx')"
          >
            {{ $t('PQTOffersView.excelXar') }}
          </b-button>
          <b-button
            class="col-3"
            @click="exportResultsDetailedPrice('pdf')"
          >
            {{ $t('PQTOffersView.pdfXar') }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <div>
      <b-modal
        v-model="showOnlyPriceComparison"
        size="lg"
      >
        <template #modal-title>
          {{ $t('yalnzQiymtMqayissiCdvli') }}
        </template>
        <table class="table">
          <thead>
            <tr>
              <th>{{ $t('mhsullar') }}</th>
              <!-- Dynamically generate header cells for each company -->
              <th
                v-for="company in companies"
                :key="company"
              >
                {{ company }}
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- Dynamically generate table rows for product data -->
            <tr
              v-for="(row, index) in onlyPriceComparisonData"
              :key="index"
              :class="{'bold-row': row.Məhsullar === 'Cəmi Məbləğ'}"
            >
              <td>{{ row.Məhsullar }}</td>
              <!-- Dynamically generate data cells for each company's price -->
              <td
                v-for="company in companies"
                :key="company"
              >
                {{ row[company] }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row pl-5 align-end">
          <b-button
            class="col-4 mr-5"
            @click="exportResultsOnlyPrice('xlsx')"
          >
            {{ $t('PQTOffersView.excelXar') }}
          </b-button>
          <b-button
            class="col-3"
            @click="exportResultsOnlyPrice('pdf')"
          >
            {{ $t('PQTOffersView.pdfXar') }}
          </b-button>
        </div>
      </b-modal>
    </div>

    <div
      v-for="o in offers"
      :key="o.id"
      class="card-body"
    >
      <hr class="dashed">
      <div class="row">
        <div class="col-md-6">
          <strong>
            {{ o.requestUser.company.name }}
            {{ getCompanyFormat(o.requestUser.company.format) }}
          </strong> <br>
          <StarRatingView
            :count="o.requestUser.company.supplyRateCount"
            :total="o.requestUser.company.supplyRateTotal"
            @click.prevent="openCompanyRatingStatisticPopup=o.requestUser.company.id"
          />
          <i
            v-b-modal.modal-company-rate-statists
            class="fa fa-info-circle"
            @click.prevent="$emit('openCompanyRatingStatisticPopup',o.requestUser.company.id)"
          />
        </div>
        <div class="col-md-6 text-left text-md-right">
          <strong class="badge bg-primary lead p-2">
            {{ $t('PQTOffersView.ototalpriceAzn', {totalPrice: o.totalPrice}) }}
          </strong> <br>
          <em>(toplam)</em>
        </div>
      </div>

      <div
        v-for="pc in getPQTPrices(o.prices)"
        :key="pc.product.id"
      >
        <hr>
        <div
          :key="o.id"
          class="row"
        >
          <div class="col-6">
            <strong>{{ pc.product.name }}</strong> ({{ pc.product.count }} {{ pc.product.unit }})
            <span v-if="pc.product.note"><br>{{ pc.product.note }}  </span>
          </div>
          <div class="col-6 text-right">
            <strong>
              {{ $t('PQTOffersView.pcpriceAzn', {price: pc.price}) }}
            </strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StarRatingView from "@/pages/scc/utils/StarRatingView.vue"
import {
  exportRequestResult,
  exportRequestResultDetailed,
  exportRequestResultPrice
} from "@/repositories/GeneralDataRepository";
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {getCompanyFormat, getPhoto,} from "@/repositories/Utils";
import {startNewOfferConversation} from "../../../repositories/GeneralDataRepository";

export default {
  name: 'PQTOffersView',
  components: {
    StarRatingView,
  },
  props: {
    request: {
      type: Object,
      default() {
        return {}
      }
    },
    offers: {
      type: Array,
      default() {
        return []
      }
    },
    products: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      showOnlyPriceComparison: false,
      showDetailedView: false
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token
    }),

    onlyPriceComparisonData() {

      const flatOffers = this.offers.flatMap(offer => {
        const companyName = offer.requestUser.company.name;
        const prices = this.parsePrices(offer.prices).prices;
        return prices.map(priceInfo => ({
          productId: priceInfo.product,
          companyName: companyName,
          price: priceInfo.price
        }));
      });

      const groupedByProduct = flatOffers.reduce((acc, offer) => {
        const {productId, companyName, price} = offer;
        let product = this.getProductById(productId);
        if (!acc[productId]) {
          acc[productId] = {Məhsullar: `${product.name}`};
        }
        acc[productId][companyName] = price;
        return acc;
      }, {});

      let result = Object.values(groupedByProduct);
      const totalSum = {Məhsullar: 'Cəmi Məbləğ'};

      this.offers.forEach(o => {
        const name = o.requestUser.company.name;
        totalSum[name] = 0;
      });

      result.forEach(productRow => {
        Object.keys(productRow).forEach(companyName => {
          const price = parseFloat(productRow[companyName]);
          if (!isNaN(price)) {
            totalSum[companyName] += price;
          }
        });
      });

      result.push(totalSum);
      return result;
    },
    companies() {
      if (!this.onlyPriceComparisonData.length) return [];
      const [firstRow] = this.onlyPriceComparisonData;
      return Object.keys(firstRow).filter(key => key !== 'Məhsullar');
    }
  },

  emits: ['openCompanyRatingStatisticPopup'],
  methods: {

    getProduct(productId) {
      return this.products.find(product => product.id === productId) || {};
    },

    getParsedPrices(offer) {
      return JSON.parse(offer.prices).prices;
    },

    getTechSpecification(offer, pId) {
      return this.getParsedPrices(offer).find(p => p.product === pId);
    },

    getParsedPricesExtras(offer) {
      return this.parsePrices(offer.prices).extras;
    },

    getRequirementReply(priceDetail, requirementId) {
      const requirementDetail = priceDetail.reqDetails.find(detail => detail.id === requirementId);
      return requirementDetail ? requirementDetail.detail : 'No reply';
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },

    parsePrices(pricesJSON) {
      try {
        return JSON.parse(pricesJSON);
      } catch (e) {
        return {};
      }
    },

    getPQTPrices(offerData) {
      let prices = [];
      let json = JSON.parse(offerData);
      json.prices.forEach((k) => {
        prices.push({
          product: this.getProductById(k.product),
          price: k.price,
        })
      })
      return prices;
    },

    getProductById(id) {

      let prod;
      this.products.forEach(p => {
        if (p.id === parseInt(id)) {
          prod = p;
        }
      })

      return prod;

    },

    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },

    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    exportResults(format) {

      exportRequestResult(this.token, this.request.id, format).then(data => {
        if (data.code === 200) {
          window.open(mediaBase + data.file);
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      });
    },
    exportResultsOnlyPrice(format) {

      exportRequestResultPrice(this.token, this.request.id, format, this.$i18n.locale).then(data => {
        if (data.code === 200) {
          window.open(mediaBase + data.file);
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      });
    },
    exportResultsDetailedPrice(format) {

      exportRequestResultDetailed(this.token, this.request.id, format, this.$i18n.locale).then(data => {
        if (data.code === 200) {
          window.open(mediaBase + data.file);
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      });

    },

    startConversation(requestUserId) {

      startNewOfferConversation(this.token, this.request.id, requestUserId).then(data => {

        if (data.code === 200) {
          this.$router.push(`/dashboard/conversation/${data.id}`);
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          })
        }

      });
    }
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}

.offer-container {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  padding: 1rem;
}

.list-unstyled {
  padding-left: 0;
}

.font-weight-bold {
  font-weight: bold;
}

table {
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.custom-row-height {
  max-height: 10px;
}

.bold-row {
  font-weight: bold;
}

hr.dashed {
  border-style: dashed;
  border-color: lightblue;
  border-width: 0.1rem;
}

.file-style {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
</style>
